const COLORS = {
    hsl207090021: 'hsl(207, 90%, 21%)',
    hsl000000030: 'hsl(0, 0%, 80%)',
    rgba204204204050: 'rgba(204, 204, 204, 0.5)',
    rgba204204204070: 'rgba(204, 204, 204, 0.7)',
    white: 'hsl(0, 0%, 100%)',
    white2: 'hsl(0, 0%, 97%)',
    black: 'hsl(0, 0%, 0%)',
    black1: 'hsl(0, 0%, 10%)',
    hsl00000090: 'hsl(0, 0%, 90%)',
    hsl210004055: 'hsl(210, 4%, 55%)',  // grey text
    hsl00000050: 'hsl(0, 0%, 78%)', //grey
    hsl00000010: 'hsl(0, 0%, 10%)', //grey
    hsl031070060: 'hsl(31, 70%, 60%)',
    hsl177063032: 'hsl(177, 63%, 32%)', // turqoise
    hsl177063070: 'hsl(177, 63%, 70%)', // turqoise light
    hsl177063027: 'hsl(177, 63%, 27%)', // turqoise dark
    rgba178178178030: 'rgba(178, 178, 178, 0.3)',// grey borders
    hsl000000098: 'hsl(0, 0%, 98%)',
    hsl000000092: 'hsl(0, 0%, 92%)',
    hsl003100059: 'hsl(3, 100%, 59%)',
    hsl000100099: 'hsl(0, 100%, 99%)', // light red
    hsl000000083: 'hsl(0, 0%, 83%)', // grey input border
    hsl214054043: 'hsl(214, 54%, 43%)', // blue border input
    hsl220003087: 'hsl(220, 3%, 87%)', // grey placeholder
    hsl003079056: 'hsl(3, 79%, 56%)',
    hsl000000056: 'hsl(0, 0%, 56%)',
    hsl218001016: 'hsl(218, 10%, 16%)',
    hsl210003087: 'hsl(210, 3%, 87%)', // devices table header
    hsl210003050: 'hsl(210, 3%, 50%)',  // devices table header
    mainOrange: 'hsl(23, 100%, 52%)',
    mainOrangeLight: 'hsl(23, 100%, 57%)',
    mainOrangeDa1rker: 'hsl(23, 100%, 42%)',
    mainTeal: 'hsl(191, 48%, 40%)',
    mainTealLight: 'hsl(177, 42%, 90%)',
    mainTealDark: 'hsl(191, 48%, 45%)',
    coral: 'hsl(11, 81%, 77%)',
    coral50opacity: 'rgba(244, 166, 149, 0.5)',
    rgba000000000014: 'rgba(0, 0, 0, 0.14)',    // shadow black

    // Brand colors from reference design
    brandBlack: '#0D1017',
    brandPurple: '#735BF2',
    brandPurpleLight: '#F2F0FF',
    brandBg: '#F9F9FA',
    hsl35796098: 'hsl(357, 96%, 98%)',  // Background purple light gradient
    hsl003076099: 'hsl(3, 76%, 99%)',   // Background pink gradient

    // Fresha-style minimal color palette
    freshaBlack: '#000000',
    freshaWhite: '#FFFFFF',
    freshaGray50: '#f9fafb',
    freshaGray100: '#f3f4f6',
    freshaGray200: '#e5e7eb',
    freshaGray400: '#9ca3af',
    freshaGray500: '#6b7280',
    freshaGray600: '#4b5563',
    freshaGray700: '#374151',
    freshaGray900: '#111827',
}

export default COLORS;